import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

function AuthModal({ onClose }) {
  const { isAuthenticated, isAdmin, logout, login, register, resetPassword } = useAuth();
  const [mode, setMode] = useState('login'); // 'login' | 'register'
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [showPwd2, setShowPwd2] = useState(false);
  const [showPwdConfirm, setShowPwdConfirm] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setInfo('');
    setLoading(true);
    try {
      await login(email, password);
      onClose();
    } catch (err) {
      setError(err?.message || 'Connexion impossible');
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setInfo('');
    setLoading(true);
    try {
      await register({ email, password, passwordConfirm, name });
      onClose();
    } catch (err) {
      setError(err?.message || "Inscription impossible");
    } finally {
      setLoading(false);
    }
  };

  const handleForgot = async () => {
    setError('');
    setInfo('');
    if (!email) {
      setError('Veuillez saisir votre email pour réinitialiser votre mot de passe.');
      return;
    }
    try {
      await resetPassword(email);
      setInfo('Un email de réinitialisation a été envoyé (si le compte existe).');
    } catch (err) {
      setError(err?.message || 'Impossible d\'envoyer l\'email de réinitialisation');
    }
  };

  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{isAuthenticated ? 'Mon espace' : 'Bienvenue'}</h3>
          <button className="modal-close" aria-label="Fermer" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          {isAuthenticated ? (
            <div className="grid grid-2">
              <Link className="btn btn-primary" to="/mon-compte" onClick={onClose}>Mon compte</Link>
              {isAdmin ? (
                <Link className="btn btn-ghost" to="/admin" onClick={onClose}>Administration</Link>
              ) : null}
              <button className="btn btn-ghost" type="button" onClick={() => { logout(); onClose(); }}>Se déconnecter</button>
            </div>
          ) : (
            <>
              <div className="auth-tabs">
                <button
                  type="button"
                  className={`auth-tab ${mode === 'login' ? 'auth-tab-active' : ''}`}
                  onClick={() => { setMode('login'); setError(''); }}
                >
                  Se connecter
                </button>
                <button
                  type="button"
                  className={`auth-tab ${mode === 'register' ? 'auth-tab-active' : ''}`}
                  onClick={() => { setMode('register'); setError(''); }}
                >
                  Créer un compte
                </button>
              </div>

              {mode === 'login' ? (
                <form onSubmit={handleLogin}>
                  <div className="form-group">
                    <label htmlFor="auth_email">Email</label>
                    <input id="auth_email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                  </div>
                  <div className="form-group password-field">
                    <label htmlFor="auth_password">Mot de passe</label>
                    <input
                      id="auth_password"
                      type={showPwd ? 'text' : 'password'}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <button
                      type="button"
                      className="password-toggle"
                      aria-label={showPwd ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
                      onClick={() => setShowPwd((v) => !v)}
                    >
                      {showPwd ? <EyeOffIcon /> : <EyeIcon />}
                    </button>
                  </div>
                  {error ? <p style={{ color: '#ef4444', marginTop: 8 }}>{error}</p> : null}
                  {info ? <p style={{ color: '#10b981', marginTop: 8 }}>{info}</p> : null}
                  <div style={{ display: 'flex', gap: 12, marginTop: 12 }}>
                    <button className="btn btn-primary" type="submit" disabled={loading}>
                      {loading ? 'Connexion…' : 'Se connecter'}
                    </button>
                  </div>
                  <div className="auth-inline-links">
                    <button type="button" className="link-button" onClick={handleForgot}>Mot de passe oublié ?</button>
                    <span className="sep">•</span>
                    <button type="button" className="link-button" onClick={() => { setMode('register'); setError(''); setInfo(''); }}>Pas encore de compte ?</button>
                  </div>
                </form>
              ) : (
                <form onSubmit={handleRegister}>
                  <div className="form-group">
                    <label htmlFor="auth_name">Nom</label>
                    <input id="auth_name" value={name} onChange={(e) => setName(e.target.value)} />
                  </div>
                  <div className="form-group">
                    <label htmlFor="auth_email2">Email</label>
                    <input id="auth_email2" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                  </div>
                  <div className="form-group password-field">
                    <label htmlFor="auth_password2">Mot de passe</label>
                    <input
                      id="auth_password2"
                      type={showPwd2 ? 'text' : 'password'}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <button
                      type="button"
                      className="password-toggle"
                      aria-label={showPwd2 ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
                      onClick={() => setShowPwd2((v) => !v)}
                    >
                      {showPwd2 ? <EyeOffIcon /> : <EyeIcon />}
                    </button>
                  </div>
                  <div className="form-group password-field">
                    <label htmlFor="auth_password_confirm">Confirmer le mot de passe</label>
                    <input
                      id="auth_password_confirm"
                      type={showPwdConfirm ? 'text' : 'password'}
                      value={passwordConfirm}
                      onChange={(e) => setPasswordConfirm(e.target.value)}
                      required
                    />
                    <button
                      type="button"
                      className="password-toggle"
                      aria-label={showPwdConfirm ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
                      onClick={() => setShowPwdConfirm((v) => !v)}
                    >
                      {showPwdConfirm ? <EyeOffIcon /> : <EyeIcon />}
                    </button>
                  </div>
                  {error ? <p style={{ color: '#ef4444', marginTop: 8 }}>{error}</p> : null}
                  <div style={{ display: 'flex', gap: 12, marginTop: 12 }}>
                    <button className="btn btn-primary" type="submit" disabled={loading}>
                      {loading ? 'Création…' : 'Créer le compte'}
                    </button>
                  </div>
                  <div className="auth-inline-links">
                    <button type="button" className="link-button" onClick={() => { setMode('login'); setError(''); setInfo(''); }}>Déjà un compte ?</button>
                  </div>
                </form>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function EyeIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

function EyeOffIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 3l18 18" />
      <path d="M10.584 10.59A3 3 0 0012 15a3 3 0 002.41-4.417" />
      <path d="M9.88 4.24A10.94 10.94 0 0112 4c7 0 11 8 11 8a17.2 17.2 0 01-3.17 3.95M6.61 6.61A17.6 17.6 0 001 12s4 8 11 8a10.9 10.9 0 005.39-1.46" />
    </svg>
  );
}

export default AuthModal;
